import { AbstractControl, ValidationErrors } from '@angular/forms';

export abstract class AbstractValueAccessor {
  protected errorMessage: string;
  protected internalValid = true;

  protected constructor() {
    this.errorMessage = 'Please enter a valid date format';
  }

  // Allows Angular to register a function to call when the model changes.
  protected onChange = _ => {};
  registerOnChange(fn: (value: Value) => void): void {
    this.onChange = fn;
  }

  // Allows Angular to register a function to call when the input has been touched.
  onTouched = () => {};
  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  // Allows Angular to register a function to call when the validator inputs change.
  protected onValidatorChange = () => {};
  registerOnValidatorChange(fn: () => void): void {
    this.onValidatorChange = fn;
  }

  // disable the input.
  abstract setDisabledState(isDisabled: boolean): void;

  // update value
  abstract writeValue(value: Value): void;

  validate(control: AbstractControl): ValidationErrors | null {
    if (!control.value || (!control.value.month && !control.value.year)) {
      this.internalValid = true;
      return null;
    }
    const date = new Date();
    date.setFullYear(control.value.year);
    date.setMonth(control.value.month - 1);
    const validationErrors = !isNaN(date.getTime())
      ? null
      : {
          inputError: this.errorMessage
        };
    this.internalValid = !validationErrors;
    return validationErrors;
  }
}

export interface Value {
  year: number;
  month: number;
}
